import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="py-24 bg-wine relative overflow-hidden" data-id="element-57">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-58">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-59"></div>
        <div className="absolute bottom-0 right-0 w-1/2 h-1/2 rounded-tl-full bg-gold blur-3xl" data-id="element-60"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-62">
          <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white font-bold mb-6 leading-tight" data-id="element-63">
            Ready to Make Every Bottle{' '}
            <span className="italic text-gold font-normal" data-id="element-64">Personal?</span>
          </h2>

          <p className="text-lg md:text-xl text-cream-100 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-65">
            Start with just 12 bottles. Choose your wine, design your label, and
            create something memorable for your next event or collection.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-66">
            <a href="/design" className="w-full sm:w-auto px-8 py-4 bg-gold text-charcoal rounded-sm font-bold hover:bg-white transition-colors duration-300 shadow-lg" data-id="element-67">
              Get Started
            </a>
            <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/30 text-white rounded-sm font-medium hover:bg-white/10 hover:border-white transition-all duration-300" data-id="element-68">
              Contact Us
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}